export function FaqContainer({ children }: { children: React.ReactNode }) {
  return (
    <div className="mx-auto max-w-4xl divide-y divide-gray-900/10">
      <dl className="space-y-6 divide-y divide-gray-900/10">{children}</dl>
    </div>
  );
}
